<script>
export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: 'Text',
  props: {
    text: { type: String },
    mainClass: { type: String, default: '' },
  },
}
</script>

<template lang="pug">
.text-black-15(v-if="!text?.length") empty
div(
  v-else-if="text.length > 250"
  :class="mainClass"
  style="max-width: 300px; word-wrap: break-word"
  v-tooltip="text"
) {{ text.substring(0, 250) }}...
div(v-else :class="mainClass" style="max-width: 300px; word-wrap: break-word") {{ text }}
</template>

<style scoped lang="scss"></style>
